import { c as _c } from "react/compiler-runtime";
import { CONTACT_API } from 'modules/contacts/api/contact-api';
import { StoreUtmParametersInterface } from 'modules/contacts/types/contact-filter-interface';
import useUser from 'shared/hooks/use-user';
import { baseFetcher } from 'shared/utils/http-client';
import useSWR from 'swr';
export function useNeedShowUtmParameters() {
  const $ = _c(2);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] !== user) {
    t0 = () => {
      if (!user) {
        return;
      }
      return `${CONTACT_API}/bulk-actions/options`;
    };
    $[0] = user;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data
  } = useSWR(t0, baseFetcher);
  if (data) {
    return data.storeUtmData;
  }
}